import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import groups from 'modules/dashboard/store/collections/communities/Groups'

interface Props {
  onClose: () => void
  groupId: number
}

function DeleteGroup({ onClose, groupId }: Props) {
  const { loading } = useAsyncData(
    () =>
      groups.fetch({
        data: {
          id: groupId,
        },
        remove: false,
      }),
    [groupId]
  )

  const group = groups.find({
    id: groupId,
  })

  const submit = async (closePortal: ClosePortalFn) => {
    if (!group) return

    const { success } = await asyncAction(() => group.rpc('archive'))

    if (success) {
      groups.remove(group)
      closePortal()
    }
  }

  if (group && group.isDefault) onClose()

  return (
    <Modal
      description={i18n.t('dashboard.groups.delete.description')}
      illustration="delete"
      onClose={onClose}
      onSubmit={submit}
      title={i18n.t('dashboard.groups.delete.title')}
      footer={
        <Button type="negative" disabled={loading || !group} submit>
          {i18n.t('dashboard.groups.delete.title')}
        </Button>
      }
    />
  )
}

export default observer(DeleteGroup)
